export default __webpack_public_path__ + "img/share_social-4f2ed7247ca8be43c0c65fc0f36fb6ca.png";